import { createSlice } from '@reduxjs/toolkit';
import { fCustomDate } from '../../utils/formatTime';
// ----------------------------------------------------------------------

const thirtyDaysAgo = new Date();
const currentDate = new Date();
thirtyDaysAgo.setDate(currentDate.getDate() - 30);
const initialState = {
  retailUsersListFilters: {
    search: '',
    is_funded: '',
    kyc_status: '',
    showFilters: false,
  },
  retailUserTransactionsListFilters: {
    search: '',
    status: '',
    type: '',
    created_date_after: fCustomDate(new Date(thirtyDaysAgo)),
    created_date_before: fCustomDate(new Date(currentDate)),
    showFilters: false,
  },

  // merchant
  merchantUsersListFilters: {
    search: '',
    is_funded: '',
    kyb_status: '',
    showFilters: false,
  },

  // retail KYC
  identomatListKycFilters: {
    search: '',
    status: '',
    document_type: '',
    from_date: fCustomDate(new Date(thirtyDaysAgo)),
    to_date: fCustomDate(new Date(currentDate)),
    showFilters: false,
  },
  immersveListKycFilters: {
    search: '',
    status: '',
    from_date: fCustomDate(new Date(thirtyDaysAgo)),
    to_date: fCustomDate(new Date(currentDate)),
  },

  // merchant KYC
  merchantKybListFilters: {
    search: '',
    status: '',
    showFilters: false,
  },

  // Bitgo Trannsctionns
  bitgoTransactionsListFilters: {
    search: '',
    status: '',
    created_date_after: fCustomDate(new Date(thirtyDaysAgo)),
    created_date_before: fCustomDate(new Date(currentDate)),
    showFilters: false,
  },

  // Circle Yransactions
  circleTransactionsListFilters: {
    search: '',
    status: '',
    created_date_after: fCustomDate(new Date(thirtyDaysAgo)),
    created_date_before: fCustomDate(new Date(currentDate)),
    showFilters: false,
  },

  // Bitgo Funding Queue
  bitgoFundingQueueListFilters: {
    search: '',
    status: '',
    created_date_after: fCustomDate(new Date(thirtyDaysAgo)),
    created_date_before: fCustomDate(new Date(currentDate)),
    showFilters: false,
  },

  // Circle Funding Queue
  circleFundingQueueListFilters: {
    search: '',
    status: '',
    created_date_after: fCustomDate(new Date(thirtyDaysAgo)),
    created_date_before: fCustomDate(new Date(currentDate)),
    showFilters: false,
  },
};

const slice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    // retail
    setRetailUsersListFilters(state, action) {
      state.retailUsersListFilters = {
        ...state.retailUsersListFilters,
        ...action.payload,
      };
    },

    resetRetailUsersListFilters(state) {
      state.retailUsersListFilters = initialState.retailUsersListFilters;
    },
    setRetailUserTransactionsListFilters(state, action) {
      state.retailUserTransactionsListFilters = {
        ...state.retailUserTransactionsListFilters,
        ...action.payload,
      };
    },

    resetRetailUserTransactionsListFilters(state) {
      state.retailUserTransactionsListFilters = initialState.retailUserTransactionsListFilters;
    },

    // merchant
    setMerchantUsersListFilters(state, action) {
      state.merchantUsersListFilters = {
        ...state.merchantUsersListFilters,
        ...action.payload,
      };
    },

    resetMerchantUsersListFilters(state) {
      state.merchantUsersListFilters = initialState.merchantUsersListFilters;
    },

    // retail KYC
    // setIdentomatKycListFilters
    setIdentomatKycListFilters(state, action) {
      state.identomatListKycFilters = {
        ...state.identomatListKycFilters,
        ...action.payload,
      };
    },
    // resetIdentomatKycListFilters
    resetIdentomatKycListFilters(state) {
      state.identomatListKycFilters = initialState.identomatListKycFilters;
    },

    setImmersveKycListFilters(state, action) {
      state.immersveListKycFilters = {
        ...state.immersveListKycFilters,
        ...action.payload,
      };
    },
    // resetImmersveKycListFilters
    resetImmersveKycListFilters(state) {
      state.immersveListKycFilters = initialState.immersveListKycFilters;
    },

    // merchant KYC
    setMerchantKybListFilters(state, action) {
      state.merchantKybListFilters = {
        ...state.merchantKybListFilters,
        ...action.payload,
      };
    },

    resetMerchantKybListFilters(state) {
      state.merchantKybListFilters = initialState.merchantKybListFilters;
    },

    // Bitgo Transactions
    setBitgoTransactionsListFilters(state, action) {
      state.bitgoTransactionsListFilters = {
        ...state.bitgoTransactionsListFilters,
        ...action.payload,
      };
    },
    resetBitgoTransactionsListFilters(state) {
      state.bitgoTransactionsListFilters = initialState.bitgoTransactionsListFilters;
    },

    // Circle Transactions
    setCircleTransactionsListFilters(state, action) {
      state.circleTransactionsListFilters = {
        ...state.circleTransactionsListFilters,
        ...action.payload,
      };
    },
    resetCircleTransactionsListFilters(state) {
      state.circleTransactionsListFilters = initialState.circleTransactionsListFilters;
    },

    // Bitgo Funding Queue
    setBitgoFundingQueueListFilters(state, action) {
      state.bitgoFundingQueueListFilters = {
        ...state.bitgoFundingQueueListFilters,
        ...action.payload,
      };
    },
    resetBitgoFundingQueueListFilters(state) {
      state.bitgoFundingQueueListFilters = initialState.bitgoFundingQueueListFilters;
    },

    // Circle Funding Queue
    setCircleFundingQueueListFilters(state, action) {
      state.circleFundingQueueListFilters = {
        ...state.circleFundingQueueListFilters,
        ...action.payload,
      };
    },
    resetCircleFundingQueueListFilters(state) {
      state.circleFundingQueueListFilters = initialState.circleFundingQueueListFilters;
    },
  },
});

// Reducer
export default slice.reducer;
export const {
  setRetailUsersListFilters,
  resetRetailUsersListFilters,
  setRetailUserTransactionsListFilters,
  resetRetailUserTransactionsListFilters,
  setMerchantUsersListFilters,
  resetMerchantUsersListFilters,
  setIdentomatKycListFilters,
  resetIdentomatKycListFilters,
  setImmersveKycListFilters,
  resetImmersveKycListFilters,
  setMerchantKybListFilters,
  resetMerchantKybListFilters,
  setBitgoTransactionsListFilters,
  resetBitgoTransactionsListFilters,
  setCircleTransactionsListFilters,
  resetCircleTransactionsListFilters,
  setBitgoFundingQueueListFilters,
  resetBitgoFundingQueueListFilters,
  setCircleFundingQueueListFilters,
  resetCircleFundingQueueListFilters,
} = slice.actions;
